import {
	Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel,
	FormControl, InputLabel, ListItemText, MenuItem, Select, Stack, TextField
} from "@mui/material";
import { addClient } from "api/layer";
import { AppAction, AppContext } from "helpers/context";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./add-modal.module.scss";

interface Props {
	open: boolean;
	onClose: () => void;
	onSave: () => void;
	data?: FormData;
}

interface FormData {
	id?: string;
	clientCode: string;
	clientName: string;
}

function AddModal(props: Props) {
	const [t] = useTranslation();
	const [context, dispatch] = useContext(AppContext);
	const [formData, setFormData] = useState<FormData>(
		props.data
			? { ...props.data }
			: {
				clientCode: "",
				clientName: ""
			}
	);
	const [isError, setIsError] = useState(false);

	const handleChange = (event: any) => {
		const { name, value, type, checked } = event.target;
		const val = type === "checkbox" ? checked : value;
		setFormData((prevData) => ({ ...prevData, [name]: val }));
	};

	const close = () => {
		props.onClose();
	};

	const handleSave = () => {
		let data = { ...formData };
		if (!data.clientCode || !data.clientName) {
			setIsError(true);
			return;
		}
		setIsError(false);

		if (props.data) {
			addClient(data)
				.then((res: any) => {
					if (res && res.code === 200) {
						props.onClose();
						dispatch({
							type: AppAction.addSnackBarParams,
							payload: {
								title: "editClient",
								message: "editClientSuccess",
							},
						});
					} else {
						dispatch({
							type: AppAction.addSnackBarParams,
							payload: {
								title: "editClient",
								titleIconColor: "yellow",
								titleIcon: "warning",
								resMessage: res.message,
							},
						});
					}
				})
				.finally(() => {
					props.onSave();
				});
		} else {
			addClient(data)
				.then((res: any) => {
					if (res && res.code === 200) {
						props.onClose();
						dispatch({
							type: AppAction.addSnackBarParams,
							payload: {
								title: "addClient",
								message: "addClientSuccess",
							},
						});
					} else {
						dispatch({
							type: AppAction.addSnackBarParams,
							payload: {
								title: "addClient",
								titleIconColor: "yellow",
								titleIcon: "warning",
								resMessage: res.message,
							},
						});
					}
				})
				.finally(() => {
					props.onSave();
				});
		}
	};

	return (
		<Dialog
			open={props.open}
			onClose={close}
		>
			<DialogTitle
				sx={{
					fontWeight: 600,
					fontSize: "16px",
					opacity: 0.79,
					color: "#333",
					width: "400px",
				}}
			>
				{props.data ? t("userSystem.editClient") : t("userSystem.addClient")}
			</DialogTitle>
			<DialogContent sx={{ paddingTop: "10px!important" }}>
				<Stack spacing={{ xy: 1, sm: 2 }}>
					<TextField
						required
						name="clientCode"
						value={formData.clientCode}
						error={isError && !formData.clientCode}
						onChange={handleChange}
						label={t("userSystem.clientCode")}
						variant="outlined"
						color="success"
					/>
					<TextField
						required
						name="clientName"
						value={formData.clientName}
						error={isError && !formData.clientName}
						onChange={handleChange}
						label={t("userSystem.clientName")}
						variant="outlined"
						color="success"
					/>

				</Stack>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={close}
					color="success"
				>
					{t("buttons.cancel")}
				</Button>
				<Button
					onClick={handleSave}
					color="success"
					variant="contained"
				>
					{t("buttons.save")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default AddModal;
